<template>
<transition @enter="enter" @leave="leave" appear>
  <div class="loader grid" style="opacity: 0;">
    <div class="loader__wrapper container">
      <div class="counter"><span>. {{ Math.round(counter) }}.</span></div>
      <h3>
        <span v-for="(line, index) in loader[rand]" :key="index" v-html="line" />
      </h3>
      <h5 v-show="author"><span>{{ author }}</span></h5>
    </div>
  </div>
</transition>
</template>

<script>
import { TimelineLite, TweenMax, Expo } from 'gsap/TweenMax';
import { random } from 'lodash';
import loader from '@/assets/loader.json';

export default {
  name: 'Loader',

  data() {
    return {
      loader,
      counter: 0,
      count: false,
      anim: false,
      signal: false,
    };
  },

  computed: {
    rand() {
      return random(0, this.loader.length - 1);
    },

    author() {
      let name = null;
      if (this.rand === 0) name = 'Alessandro Baricco';
      else if (this.rand > 0 && this.rand < 4) name = 'Robert M. Pirsig';
      else if (this.rand === 4) name = 'Daniel Pennac';
      return name;
    },
  },

  mounted() {
    TweenMax.to(this, 6, {
      counter: 100,
      ease: Expo.easeInOut,
      onComplete: this.out,
    });
  },

  methods: {
    enter(el, done) {
      const tl = new TimelineLite({
        onComplete: done,
      });

      const span = Array.from(el.querySelectorAll('span'));

      tl.add('start')
        .set(span, {
          autoAlpha: 0,
          yPercent: 75,
        }, 'start')
        .set(el, {
          autoAlpha: 1,
        }, 'start')
        .staggerTo(span, 1.5, {
          autoAlpha: 1,
          yPercent: 0,
          ease: Expo.easeInOut,
        }, 0.1, 'start');
    },

    out() {
      const tl = new TimelineLite({
        onComplete: () => {
          this.$store.commit('SET_LOADED', true);
        },
      });

      const span = Array.from(this.$el.querySelectorAll('span'));

      tl.add('start')
        .staggerTo(span, 0.75, {
          autoAlpha: 0,
          yPercent: 50,
          ease: Expo.easeInOut,
        }, -0.05, 'start');
    },

    leave(el, done) {
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  z-index: 100;

  // display: flex;
  // flex-flow: row wrap;
  align-items: center;

  @include mq(ipadP) {
    padding: rem(60px) rem(40px);
  }

  .counter {
    color: $color-gray;
    font-size: rem(14px);
    margin-bottom: rem(44px);
  }

  span {
    position: relative;
    display: block;
  }
}
</style>
